<template>
  <div class="custom-container" v-loading.fullscreen.lock="customerNew.isLoading">
    <el-row type="flex" justify="space-between" style="align-items: center">
      <p class="category-title my-2"> Customer Baru Details </p>
      <el-button
        type="primary"
        size="small"
        @click="$router.push({ name: 'print-customer-new', params: { customerNew: customerNew.data } })"
      >Form Preview</el-button>
    </el-row>

    <el-row :gutter="20" class="mt-4">
      <el-col :lg="12" :md="12">
        <el-card class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold">Customer</span>
          </el-row>
          <el-row>
            <el-row v-for="item in detailCompany" :key="item.label" type="flex" align="middle" class="mb-2">
              <el-col :span="8">
                <span>{{ item.label }}</span>
              </el-col>
              <el-col :span="1">
                <span>:</span>
              </el-col>
              <el-col :span="16">
                <el-input
                  placeholder="Please input"
                  v-model="customerNew.data[item.value]"
                  :disabled="true">
                </el-input>
              </el-col>
            </el-row>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="mt-4">
      <el-col :lg="12" :md="12">
        <el-card class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold;">Shipping Address</span>
          </el-row>
          <el-row v-if="customerNew.data.ship_to">
            <template v-for="(value, name, index) in shippingAddress">
              <el-col :span="7" :key="index">{{ value }}</el-col>
              <el-col :span="1" :key="index + value">
                <span>:</span>
              </el-col>
              <el-col :span="16" :key="value">
                {{
                customerNew.data.ship_to[name] || "-"
                }}
              </el-col>
            </template>
          </el-row>
        </el-card>
        <el-card class="mb-2" shadow="never">
          <el-row class="mb-2">
            <span style="font-size: 16px; font-weight: bold;">Billng Address</span>
          </el-row>
          <el-row v-if="customerNew.data.bill_to">
            <template v-for="(value, name, index) in billAddress">
              <el-col :span="7" :key="index">{{ value }}</el-col>
              <el-col :span="1" :key="index + value">
                <span>:</span>
              </el-col>
              <el-col :span="16" :key="value">
                {{
                customerNew.data.bill_to[name] || "-"
                }}
              </el-col>
            </template>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["id"],
  components: {},
  data: () => ({
    formReturs: {
      paymentValue: "",
      paymentNote: "",
      attachment: ""
    },
    valid: true,
    detailCompany: [
      {
        label: 'Company/Outlate Name',
        value: 'company_name'
      },
      {
        label: 'Owner',
        value: 'owner'
      },
      {
        label: 'Business Entity',
        value: 'bussines_entity'
      },
      {
        label: 'NIK',
        value: 'nik'
      },
      {
        label: 'NPWP',
        value: 'npwp'
      },
      {
        label: 'Telp. No',
        value: 'tlp'
      },
      {
        label: 'Email Address',
        value: 'email_address'
      }
    ],
    shippingAddress: {
      country: "Country",
      province: "Province",
      city: "City",
      state: "State",
      address: "Address",
      postal_code: "Postal Code",
      phone_number: "Phone Number",
      contact_person: "Contact Person",
      contact_phone_number: "CP Contact"
    },
    billAddress: {
      country: "Country",
      province: "Province",
      city: "City",
      state: "State",
      address: "Address",
      postal_code: "Postal Code",
      phone_number: "Phone Number",
      contact_person: "Contact Person",
      contact_phone_number: "CP Contact"
    },
    shipping: {
      estimateArrival: "Estimate Arrival",
      status: "Status"
    }
  }),
  computed: {
    ...mapState({
      customerNew: state => state.customerNew.customerNew,
    })
  },
  methods: {
    ...mapActions({
      getCustomerNew: "customerNew/GetCustomerNew",
      updateCustomerNew: "customerNew/UpdateCustomerNew",
    }),
    save() {
      this.$refs.formReturs.validate(valid => {
        const payload = {
          customerNewId: this.customerNew.data.customerNewId,
        };
        if (valid) {
          this.updateRetur(payload);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    },
  },
  created() {
    const params = {
      id: this.id,
    };
    this.getCustomerNew(params);
  }
};
</script>

<style>
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
.qrCodeNotAvailable {
  width: 350px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  font-weight: bold;
}
</style>
